<div class="setting-main-wrapper">
    <div class="row">
        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4" *ngIf="dbLookUpItemsNew && dbLookUpItemsNew.length > 0">
            <div class="div-wrapper lookup-wrapper" [ngClass]="dbLookUpItemsNew.length == 0 ? 'no-field-wrapper' : ''">
                <div class="lookup-head">
                    <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.DATABASE_SELECT_LOOKUP' | transloco }}</h4>
                    <div class="icon-wrapper">
                        <button class="btn primary-ebtn" *ngIf="isDbLookUpAdd" (click)="addNewRow()">
                            <mat-icon class="" matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}">add</mat-icon>
                        </button>
                        <button class="btn primary-ebtn" [disabled]="disableEdit" (click)="saveAllChanges()">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.SAVE' | transloco }}">save</mat-icon>
                        </button>
                        <button class="btn primary-ebtn" [disabled]="disableCancel" (click)="undoAllChanges(0)">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.UNDO' | transloco }}">undo</mat-icon>
                        </button>
                    </div>
                </div>

                <div id="tree-list-demo" class="field-wrapper">
                    <dx-tree-list
                        class="tree-list-2"
                        #treeList
                        [dataSource]="dbLookUpItemsNew"
                        keyExpr="databaseSelectId"
                        parentIdExpr="parentId"
                        [columnAutoWidth]="true"
                        [wordWrapEnabled]="true"
                        [showBorders]="true"
                        [showColumnHeaders]="false"
                        (onInitNewRow)="initNewRow($event)"
                        (onRowInserted)="onRowInserted($event)"
                        (onRowUpdated)="onRowUpdated($event)"
                        (onRowRemoved)="onRowRemoved($event)"
                        (onToolbarPreparing)="customizeToolbar($event)"
                        (onCellPrepared)="handleCellPrepared($event)"
                        (onCellValueChanged)="trackEditedCell($event)"
                        (onSaving)="handleSaving($event)"
                        (onRowPrepared)="handleRowPrepared($event)"
                        (onRowRemoving)="handleRowRemoving($event)"
                        (deleteRow)="handledeleteRow($event)"
                        (undeleteRow)="handleundeleteRow($event)"
                        (onOptionChanged)="handlePropertyChange($event)"
                        (onEditorPreparing)="onEditorPreparingDBSelect($event)"
                    >
                        <dxo-editing
                            mode="batch"
                            [allowDeleting]="isDbLookUpDelete"
                            [allowAdding]="allowAdding"
                            [allowUpdating]="isDbLookUpUpdate"
                            [useIcons]="true"
                        >
                        </dxo-editing>
                        <dxi-column dataField="name" [minWidth]="250">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dxi-column>
                    </dx-tree-list>
                </div>

                <ng-template #noLookUp>
                    <div class="heading-wrapper d-flex justify-content-center align-items-center">
                        <h3 class="text-dark">{{ 'SETTING_PAGE.IDMS_SETTINGS.NO_LOOK_UP_FIELDS_ADDED_YET' | transloco }}!</h3>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-8" *ngIf="isMaterialAliasView">
            <div class="div-wrapper lookup-wrapper" [ngClass]="materialAliasList.length == 0 ? 'no-field-wrapper' : ''">
                <div class="lookup-head">
                    <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.MATERIAL_ALIASES' | transloco }}</h4>
                    <div class="icon-wrapper">
                        <button class="btn primary-ebtn" [disabled]="disableEditMaterialAlias" (click)="saveMaterialAliasAllChanges()">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.SAVE' | transloco }}">save</mat-icon>
                        </button>
                        <button class="btn primary-ebtn" [disabled]="disableCancelMaterialAlias" (click)="undoAllChangesMaterialAlias(0)">
                            <mat-icon class=" " matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.UNDO' | transloco }}">undo</mat-icon>
                        </button>
                    </div>
                </div>

                <div id="tree-list-demo" class="field-wrapper" *ngIf="materialAliasTypesList && materialAliasTypesList.length > 0">
                    <dx-tree-list
                        class="tree-list-1 materail-alias"
                        #treeList2
                        [dataSource]="materialAliasTypesList"
                        keyExpr="materialAliasId"
                        parentIdExpr="parentId"
                        [wordWrapEnabled]="true"
                        [showBorders]="true"
                        [showColumnHeaders]="false"
                        (onCellClick)="onCellClick($event)"
                        [columnAutoWidth]="false"
                        (onToolbarPreparing)="customizeToolbar($event)"
                        (onOptionChanged)="handleMaterialAliasPropertyChange($event)"
                        (deleteRow)="handledeleteRow($event)"
                        (onSaving)="handleMaterialAliasSaving($event)"
                        (onCellValueChanged)="trackEditedCell($event)"
                        (onInitNewRow)="initMaterialAliasNewRow($event)"
                        (onCellPrepared)="materialAliasCellPrepared($event)"
                        (onRowPrepared)="materialAliashandleRowPrepared($event)"
                        (onFocusedCellChanged)="handleCellFocus($event)"
                        (onEditorPreparing)="onEditorPreparing($event)"
                        (rowPrepared)="onRowPrepared($event)"
                    >
                        <dxo-editing
                            mode="batch"
                            [allowDeleting]="allowDelete2"
                            [allowAdding]="allowAdding2"
                            [allowUpdating]="isMaterialALiasUpdate"
                            [useIcons]="true"
                        >
                        </dxo-editing>
                        <dxi-column alignment="left" [minWidth]="200" dataField="name" [displayName]="displayName2" [allowEditing]="false"> </dxi-column>
                        <dxi-column alignment="left" dataField="qualifiedName" [minWidth]="350" caption="qualifiedName" dataType="string"> </dxi-column>
                        <dxi-column alignment="left" dataField="alias" [minWidth]="200"> </dxi-column>
                    </dx-tree-list>
                </div>
                <ng-template #noMaterialAlias>
                    <div class="heading-wrapper d-flex justify-content-center align-items-center">
                        <h3 class="text-dark">{{ 'SETTING_PAGE.IDMS_SETTINGS.NO_MATERIAL_ALIAS_ADDED_YET' | transloco }}!</h3>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
